export const EXPORT_TO_CSV_REQUEST = 'EXPORT_TO_CSV_REQUEST';
export const EXPORT_TO_CSV_SUCCESS = 'EXPORT_TO_CSV_SUCCESS';
export const EXPORT_TO_CSV_FAILURE = 'EXPORT_TO_CSV_FAILURE';

export const DASHBOARD_DETAILS_REQUEST = 'DASHBOARD_DETAILS_REQUEST';
export const DASHBOARD_DETAILS_SUCCESS = 'DASHBOARD_DETAILS_SUCCESS';
export const DASHBOARD_DETAILS_FAILURE = 'DASHBOARD_DETAILS_FAILURE';

export const PROVIDER_REQUEST_DAILY_COUNTS_REQUEST = 'PROVIDER_REQUEST_DAILY_COUNTS_REQUEST';
export const PROVIDER_REQUEST_DAILY_COUNTS_SUCCESS = 'PROVIDER_REQUEST_DAILY_COUNTS_SUCCESS';
export const PROVIDER_REQUEST_DAILY_COUNTS_FAILURE = 'PROVIDER_REQUEST_DAILY_COUNTS_FAILURE';

export const QGENDA_TASKS_SCHEDULES_REQUEST = 'QGENDA_TASKS_SCHEDULES_REQUEST';
export const QGENDA_TASKS_SCHEDULES_SUCCESS = 'QGENDA_TASKS_SCHEDULES_SUCCESS';
export const QGENDA_TASKS_SCHEDULES_FAILURE = 'QGENDA_TASKS_SCHEDULES_FAILURE';

export const SET_ALLOWED_MENUS = 'SET_ALLOWED_MENUS';
export const ALLOWED_MENUS_REQUEST = 'ALLOWED_MENUS_REQUEST';

export const UPDATE_COMMON_REDUCER = 'UPDATE_COMMON_REDUCER';

export const ASSIGNED_SITES_COUNT_REQUEST = 'ASSIGNED_SITES_COUNT_REQUEST';
export const ASSIGNED_SITES_COUNT_SUCCESS = 'ASSIGNED_SITES_COUNT_SUCCESS';
export const ASSIGNED_SITES_COUNT_FAILURE = 'ASSIGNED_SITES_COUNT_FAILURE';

export const UNASSIGNED_SITES_COUNT_REQUEST = 'UNASSIGNED_SITES_COUNT_REQUEST';
export const UNASSIGNED_SITES_COUNT_SUCCESS = 'UNASSIGNED_SITES_COUNT_SUCCESS';
export const UNASSIGNED_SITES_COUNT_FAILURE = 'UNASSIGNED_SITES_COUNT_FAILURE';

export const ASSIGNED_ROLES_WITH_PRACTICES_REQUEST = 'ASSIGNED_ROLES_WITH_PRACTICES_REQUEST';
export const ASSIGNED_ROLES_WITH_PRACTICES_SUCCESS = 'ASSIGNED_ROLES_WITH_PRACTICES_SUCCESS';
export const ASSIGNED_ROLES_WITH_PRACTICES_FAILURE = 'ASSIGNED_ROLES_WITH_PRACTICES_FAILURE';

export const SET_SHOW_LOADER = 'SET_SHOW_LOADER';

export const TENANT_CONFIGURATION_REQUEST = 'TENANT_CONFIGURATION_REQUEST';
export const TENANT_CONFIGURATION_SUCCESS = 'TENANT_CONFIGURATION_SUCCESS';
export const TENANT_CONFIGURATION_FAILURE = 'TENANT_CONFIGURATION_FAILURE';

export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const GET_TIMEZONE_FAILURE = 'GET_TIMEZONE_FAILURE';
export const DEFAULT_WORKLISTS_REQUEST = 'DEFAULT_WORKLISTS_REQUEST';
export const DEFAULT_WORKLISTS_SUCCESS = 'DEFAULT_WORKLISTS_SUCCESS';
export const DEFAULT_WORKLISTS_FAILURE = 'DEFAULT_WORKLISTS_FAILURE';
